module.exports = __webpack_public_path__ + "static/media/facebook.2c4b78c0.svg";